export default __webpack_public_path__ + "static/media/133.808f8e55.png";